// extracted by mini-css-extract-plugin
export default {"wrapper":"third_wrapper__EU51h","title":"third_title__P2Gw7","formWrapper":"third_formWrapper__rRtdC"};